module.exports = __webpack_public_path__ + "static/media/yellow-circle.8d26040b.svg";